var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DocumentProvider", {
    attrs: { document: _vm.document, currentUserRole: _vm.currentUser.role },
    on: {
      documentDeleted: function ($event) {
        return _vm.$emit("documentDeleted")
      },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function ({ download, copyLink, remove, processing }) {
            return [
              _c(
                "Processing",
                { attrs: { processing: processing } },
                [
                  _c(
                    "Card",
                    {
                      staticClass: "p-4",
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "footer",
                            fn: function () {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "flex w-full items-center" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex max-w-full truncate",
                                      },
                                      [
                                        _vm._t("optionalActions"),
                                        _vm._t("secondaryData", function () {
                                          return [
                                            _vm.isVisibleOnlyToCurrentUser
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex items-center self-center",
                                                  },
                                                  [
                                                    _c("CardInfoChip", {
                                                      staticClass:
                                                        "hidden lg:flex",
                                                      attrs: {
                                                        message:
                                                          _vm.selfVisible,
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-green-400",
                                                      },
                                                      [
                                                        _c("EyeIcon", {
                                                          staticClass:
                                                            "block lg:hidden h-6 w-6",
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        }),
                                      ],
                                      2
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "ml-auto flex items-center",
                                      },
                                      [
                                        _c(
                                          "ColorIconContainer",
                                          {
                                            staticClass: "h-8 w-8",
                                            on: { click: copyLink },
                                          },
                                          [
                                            _c("LinkIcon", {
                                              staticClass: "py-1.5",
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "ColorIconContainer",
                                          {
                                            staticClass: "h-7.5 w-7.5 ml-3",
                                            on: { click: download },
                                          },
                                          [
                                            _c("DownloadIcon", {
                                              staticClass: "py-1.5",
                                            }),
                                          ],
                                          1
                                        ),
                                        !_vm.frozen
                                          ? _c("ConfirmRemovingDocumentModal", {
                                              staticClass: "h-8 w-8 ml-3",
                                              attrs: {
                                                currentUser: _vm.currentUser,
                                                document: _vm.document,
                                                attachedToInfoHidden:
                                                  _vm.extraInfoHidden,
                                              },
                                              on: {
                                                confirmed: function ($event) {
                                                  return _vm.removeDocument(
                                                    remove
                                                  )
                                                },
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({
                                                      showModal,
                                                    }) {
                                                      return [
                                                        _c(
                                                          "ColorIconContainer",
                                                          {
                                                            on: {
                                                              click: showModal,
                                                            },
                                                          },
                                                          [
                                                            _c("TrashIcon", {
                                                              staticClass:
                                                                "py-1.5",
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("div", { staticClass: "flex w-full" }, [
                        _c(
                          "div",
                          { staticClass: "mr-4" },
                          [
                            _c("DocumentExtensionIcon", {
                              staticClass: "self-start mb-1",
                              attrs: { extension: _vm.document.format },
                            }),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "w-full overflow-hidden" }, [
                          _c("div", { staticClass: "w-full" }, [
                            _c(
                              "div",
                              {
                                staticClass: "mr-2 text-lg font-semibold mb-1",
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.document.filename) + " "
                                ),
                              ]
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass:
                                "md:flex flex-wrap w-full overflow-hidden",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-col min-w-64 w-full md:w-1/3 xlLabelContainer flex-shrink-0 mr-12",
                                },
                                [
                                  _vm._t("default"),
                                  _c(
                                    "CardBodyItem",
                                    {
                                      attrs: {
                                        label: "Uploaded by",
                                        labelClass: "mr-2",
                                        customAlign: "items-center",
                                      },
                                    },
                                    [
                                      _vm.isUploadedByCurrentUser
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "font-semibold text-sm",
                                            },
                                            [_vm._v(" You ")]
                                          )
                                        : _c("DocumentUserInformation", {
                                            attrs: {
                                              currentUserRole:
                                                _vm.currentUser.role,
                                              userId: _vm.uploadedByUser.id,
                                              userFirstName:
                                                _vm.uploadedByUser.given_name,
                                              userLastName:
                                                _vm.uploadedByUser.family_name,
                                              userRole: _vm.uploadedByUser.role,
                                              manager:
                                                _vm.uploadedByUser.manager,
                                              userAvatar:
                                                _vm.uploadedByUser.avatar,
                                            },
                                          }),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md:flex flex-wrap justify-between flex-grow xlLabelContainer lg:noWidthLabelContainer",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "min-w-48 w-full md:w-1/2" },
                                    [
                                      _c("CardBodyItem", {
                                        attrs: {
                                          content: _vm.createdAt,
                                          label: "Date",
                                          labelClass: "mr-2 md:-mr-8",
                                        },
                                      }),
                                      _c("CardBodyItem", {
                                        attrs: {
                                          content: _vm.documentFormat,
                                          label: "Format",
                                          labelClass: "mr-2 md:-mr-8",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("CardBodyItem", {
                                    staticClass: "w-full md:w-1/2",
                                    attrs: {
                                      content: _vm.documentSize,
                                      label: "Size",
                                      labelClass: "mr-2 md:-mr-8",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }